import type { NotificationAsyncDeleteCardProps } from "./notification-async-delete-card.type";

import { DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import { NotificationAsyncDeleteSuccessDescription } from "@/modules/notification/notification-async-delete";
import { NotificationCard } from "@/modules/notification/notification-card";

import { getTitleTranslationKey } from "./notification-async-delete-card.helper";

const { Paragraph } = Typography;

export const NotificationAsyncDeleteCard = ({
  notification,
}: NotificationAsyncDeleteCardProps) => {
  const { t } = useTranslation();

  const { type, data } = notification;
  const isFailed = type === "async-delete-failed";

  const color = "var(--app-color-error)";
  const Icon = isFailed ? ExclamationCircleOutlined : DeleteOutlined;

  return (
    <NotificationCard
      notification={notification}
      icon={<Icon style={{ color }} />}
      title={t(getTitleTranslationKey(notification))}
      color={color}
      content={
        <Paragraph>
          {isFailed ? (
            t("notification:asyncDelete.description.failed")
          ) : (
            <NotificationAsyncDeleteSuccessDescription data={data} />
          )}
        </Paragraph>
      }
    />
  );
};
